"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function view(props) {
    var _this = this;
    return {
        state: {
            paddingSize: "None"
        },
        initialize: function () {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        mounted: function () {
        },
        receivedProps: function (nextProps) {
            return new Promise(function (resolve) {
                resolve();
            });
        },
        unmount: function () {
        },
        events: {
            onDropdownSelect: props.onDropdownSelect,
            onBreakpoint: function (breakpoint) {
                var paddingSizes = {
                    "Min": "Medium",
                    "Xs": "Medium",
                    "Sm": "Small",
                    "Md": "Small",
                    "Lg": "Small",
                    "Xl": "Small"
                };
                _this.view.state.paddingSize = paddingSizes[breakpoint];
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// ../player-career-site-header-footer/controls/PageMenu/View.js
// module id = 439
// module chunks = 0